declare const WorkerGlobalScope: any;

export function isWorker() {
  /* istanbul ignore next */
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope
  );
}

export function getApiBaseUrl(isSSR: boolean, baseUrl?: string): string {
  if (!isSSR) {
    return location.host;
  }
  /* istanbul ignore next */
  const parsedUrlObject = new URL(baseUrl ?? '');
  return `${parsedUrlObject.hostname}${
    parsedUrlObject.pathname !== '/' ? parsedUrlObject.pathname : ''
  }`;
}

export const getTimeoutMs = (seconds: number) => 1000 * seconds;

export function guidToInt(guid: string): number {
  const reg = new RegExp(
    /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/,
  );

  if (!reg.exec(guid)) {
    return -1;
  }

  return parseInt(guid.replace(/-/g, ''), 16);
}

export function intToGuid(int: number): string {
  if (int < 0) {
    throw Error('min convertable int to guid is 0');
  }
  if (int > 2147483647) {
    throw Error('max convertable int to guid is 2147483647');
  }

  const baseGuid = '00000000-0000-0000-0000-000000000000';
  const convertedToBase16 = int.toString(16);

  return baseGuid.slice(0, -convertedToBase16.length) + convertedToBase16;
}
